function getCookie (name) {
    let reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    let arr=document.cookie.match(reg)
    if(arr)
        return unescape(arr[2]);
    if (window.location.search) {
        reg=new RegExp("[\\?\\&]"+name+"=([^\\&]*)(\\&|$)");
        arr=window.location.search.match(reg)
        if(arr)
            return unescape(arr[1]);
    }
    return null;
}

function setCookie (name, value) {
    let Days = 30;
    let exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = name + "="+ value + "; path=/; domain=.panggame.com" + "; expires=" + exp.toGMTString();
}

function storeCookies (cookies) {
    for (let i in cookies) {
        setCookie(i, cookies[i])
    }
}

function getUtm () {
    let utm_source = getCookie('utm_source')
    let res = []
    if (utm_source)
        res.push('utm_source=' + utm_source)
    let utm_campaign = getCookie('utm_campaign')
    if (utm_campaign)
        res.push('utm_campaign=' + utm_campaign)
    let utm_medium = getCookie('utm_medium')
    if (utm_medium)
        res.push('utm_medium=' + utm_medium)
    return res.join('&')
}

const lang = process.env.VUE_APP_LANG?process.env.VUE_APP_LANG:'tw'
let accountBase2 = process.env.VUE_APP_ACCOUNT_URL
if (!accountBase2)
    accountBase2 = 'https://accountth.panggame.com'
let regex = /^(https:\/\/test-|http:\/\/\d+\.).+$/
if (regex.test(window.location.href)) {
    accountBase2 = accountBase2.replace(/^(https?:\/\/)(.+)$/, '$1test-$2')
}
export const accountBase = accountBase2
const accountBaseUrl = accountBase2 + '/' + lang + '/account'
let accountUrl = accountBaseUrl
let iframe = document.createElement('iframe');
let utmParams = getUtm()
if (utmParams) {
    accountUrl = accountUrl + '?' + utmParams
}
iframe.setAttribute('src', accountUrl)
let body = document.getElementById('account-container')
iframe.setAttribute('style', 'display:none;width:100vw;border:none;min-height: calc(100vh - 100px);')
let paccountEnv = {
}

iframe.onload = function () {
    paccountEnv.iframeLoaded = true
}

function storeUser (user_info, token) {
    if (user_info) {
        window.localStorage.setItem(
            "user_info",
            JSON.stringify(user_info)
          );
        if (paccountEnv._this) {
            paccountEnv._this.screenState.user = user_info
        }
    }
    if (token) {
        window.localStorage.setItem(
            "token", token
          );
    }
}

function handleReplace (e) {
    storeUser(e.data.data.user_info, e.data.data.token)
    let url = '/account/' + e.data.data.page;
    if (e.data.data.page == 'download')
        url = '/download'
    if (paccountEnv._this) {
        let _this = paccountEnv._this
        if (e.data.data.returnurl) {
            if (_this.$route.query.returnurl) {
                let url_list = _this.$route.query.returnurl.split('?')
                let params = {}
                if (url_list.length == 2) {
                    let searchParams = new URLSearchParams(url_list[1]);
                    for(let key of searchParams.keys()) { 
                    params[key] = searchParams.get(key)
                    }
                }
                url = { path: _this.$route.query.returnurl, query: params}
            }
            else {
                url = '/account'
            }
        }
        _this.$router.replace(url)
    }
    else {
        if (e.data.data.returnurl) {
            let query = new URLSearchParams(window.location.returnurl);
            let returnurl = query.get('returnurl')
            if (returnurl)
                url = returnurl
            else
                url = '/account'
        }
        window.location = url
    }
}

if (body && body.getElementsByTagName('iframe').length == 0)
    body.appendChild(iframe)
window.addEventListener('message', function (e) {
    if (e.data.source == 'paccount') {
        switch (e.data.message) {
            case 'push':
                if (paccountEnv._this) {
                    paccountEnv._this.$router.push('/account/' + e.data.data.page)
                }
                else
                    window.location = '/account/' + e.data.data.page
                break;
            case 'replace':
                handleReplace(e)
                break;
            case 'logout':
                window.localStorage.removeItem("user_info")
                window.localStorage.removeItem("token")
                if (paccountEnv._this) {
                    paccountEnv._this.screenState.user = null
                    paccountEnv._this.$router.replace('/account/login')
                }
                else
                    window.location = '/account'
                break;
            case 'login':
                storeUser(e.data.data.user, e.data.data.data.access_token)
                if (e.data.data.cookies)
                    storeCookies(e.data.data.cookies)
                break;
            default:
                console.log(e.data);
        }
    }
})

function pushPage (page, _this) {
    paccountEnv._this = _this
    let body = document.getElementById('account-container')
    let iframes = body.getElementsByTagName('iframe')
    if (iframes.length == 0) {
        body.appendChild(iframe)
        iframe.setAttribute('src', accountBaseUrl + '/' + page + '?' + getUtm())
        iframe.style.display = 'block';
    }
    else {
        iframe = iframes[0]
        if (iframe.style.display == 'none') {
            if (paccountEnv.iframeLoaded) {
                iframe.contentWindow.postMessage({
                    message: 'push', source: 'paccountHost',
                    data: {page: page}},
                    '*')
                iframe.style.display = 'block';
            }
            else {
                iframe.setAttribute('src', accountBaseUrl + '/' + page + '?' + getUtm())
                iframe.style.display = 'block';
            }
        }
        else {
            iframe.contentWindow.postMessage({
                message: 'push', source: 'paccountHost',
                data: {page: page}},
                '*')
        }
    }
}

function unmountPage (fullPath) {
    if (fullPath.slice(0, 8) != '/account')
        iframe.style.display = 'none';
}

function logout (_this) {
    pushPage('logout', _this)
}

export default {
    accountBase: accountBase,
    pushPage: pushPage,
    unmountPage: unmountPage,
    logout: logout,
}